/* global yaCounter75719122 */
import helpers from '../helpers';
// import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	if (helpers.$html.dataset && helpers.$html.dataset.timeout15Sec) {
		clearTimeout(helpers.$html.dataset.timeout15Sec);
	}

	helpers.$html.dataset.timeout15Sec = setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000);
}

start15SecTimeout();

// scrollDepth({
// 	userTiming: false,
// 	pixelDepth: false,
// 	gtmOverride: true,
// 	eventHandler(data) {
// 		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
// 		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
// 	},
// }).addElements(['.modal__scroller']);

function getDocumentHeight() {
	return Math.max(
		document.documentElement.scrollHeight, document.body.scrollHeight,
		document.documentElement.offsetHeight, document.body.offsetHeight,
		document.documentElement.clientHeight,
	);
}

function scrollHandler(event) {
	let y = pageYOffset;
	let target = helpers.$html;
	let scroll = target.dataset.scroll || 0;

	if (event.target && event.target.classList && event.target.classList.contains('modal__scroller')) {
		y = event.target.scrollTop;
		target = event.target;
		scroll = target.dataset.scroll || 0;
	}

	if (scroll < 25 && y + innerHeight >= parseInt(getDocumentHeight() * 0.25, 10)) {
		ga('send', 'event', 'Scroll Depth', 'Percentage', '25%', {nonInteraction: false});
		ga('rbcspec.send', 'event', 'Scroll Depth', 'Percentage', '25%', {nonInteraction: false});
		scroll = 25;
		target.dataset.scroll = 25;
	} else if (scroll < 50 && scroll >= 25 &&
		y + innerHeight >= parseInt(getDocumentHeight() * 0.50, 10)) {
		ga('send', 'event', 'Scroll Depth', 'Percentage', '50%', {nonInteraction: false});
		ga('rbcspec.send', 'event', 'Scroll Depth', 'Percentage', '50%', {nonInteraction: false});
		scroll = 50;
		target.dataset.scroll = 50;
	} else if (scroll < 75 && scroll >= 50 &&
		y + innerHeight >= parseInt(getDocumentHeight() * 0.75, 10)) {
		ga('send', 'event', 'Scroll Depth', 'Percentage', '75%', {nonInteraction: false});
		ga('rbcspec.send', 'event', 'Scroll Depth', 'Percentage', '75%', {nonInteraction: false});
		scroll = 75;
		target.dataset.scroll = 75;
	} else if (scroll < 100 && y + innerHeight >= parseInt(getDocumentHeight() - 5, 10)) {
		ga('send', 'event', 'Scroll Depth', 'Percentage', '100%', {nonInteraction: false});
		ga('rbcspec.send', 'event', 'Scroll Depth', 'Percentage', '100%', {nonInteraction: false});
		scroll = 101;
		target.dataset.scroll = 101;
	}
}

function scrollDepth(container) {
	container.addEventListener('scroll', scrollHandler, false);
}

function scrollDepthReset(container) {
	container.removeEventListener('scroll', scrollHandler, false);
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter75719122) {
		yaCounter75719122.hit(path);
	}
}

document.querySelector('.header__logo--rbc').addEventListener('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

document.querySelector('.header__logo--victory').addEventListener('click', () => {
	ga('send', 'event', 'nav', 'logo header click');
});

const checkClientLink = (href) => {
	return (
		href.includes('vp.moscow')
	);
};

// клик на ссылки в тексте попапа
function modalLinks() {
	const list = document.querySelectorAll('.modal__body a');
	Array.prototype.forEach.call(list, (link) => {
		link.addEventListener('click', (e) => {
			const name = `${document.querySelector('.modal-title').textContent} | ${e.currentTarget.textContent}`;
			const href = e.currentTarget.getAttribute('href');

			if (checkClientLink(href)) {
				ga('send', 'event', 'client link', 'popup text link', helpers.clearText(name));
				ga('rbcspec.send', 'event', 'client link', 'click');
			} else {
				ga('send', 'event', 'popup', 'popup text link', helpers.clearText(name));
			}
		});
	});
}
modalLinks();

// шеры в подвале
const socials = document.querySelectorAll('.footer [data-social]');
Array.prototype.forEach.call(socials, (link) => {
	link.addEventListener('click', (e) => {
		const name = e.currentTarget.dataset.social;

		ga('send', 'event', 'share', 'project share', helpers.clearText(name));
	});
});

helpers.dispatcher
	.on('menu-open', () => {
		ga('send', 'event', 'nav', 'menu open');
	})
	.on('menu-close', () => {
		ga('send', 'event', 'nav', 'menu close');
	})
	.on('menu-click', (e) => {
		// клик на линк в меню
		ga('send', 'event', 'nav', 'menu item click', helpers.clearText(e.detail.name));
	})
	.on('cards-click', (e) => {
		// Клик на карточки
		ga('send', 'event', 'main', 'cards click', helpers.clearText(e.detail.name));
	})
	.on('cards-show', (e) => {
		// Показ попапа
		ga('send', 'event', 'cards', 'show popup', helpers.clearText(e.detail.name), {nonInteraction: true});
	})
	.on('cards-hide', (e) => {
		// Закрытие попапа
		ga('send', 'event', 'cards', 'close popup', helpers.clearText(e.detail.name));
	})
	.on('cards-switch', (e) => {
		// Смена попапа по стрелкам
		ga('send', 'event', 'popup', 'change popup', helpers.clearText(e.detail.name));
	});

export default {
	start15SecTimeout,
	virtualHit,
	scrollDepth,
	scrollDepthReset,
	modalLinks,
};
